import { render, staticRenderFns } from "./SitchDevices.vue?vue&type=template&id=e01952e0&scoped=true&"
import script from "./SitchDevices.vue?vue&type=script&lang=ts&"
export * from "./SitchDevices.vue?vue&type=script&lang=ts&"
import style0 from "./SitchDevices.vue?vue&type=style&index=0&id=e01952e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01952e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VSelect,VTextField})
